export interface MediaItem {
  key: string
  url: string
  size: number
  contentType: string
  uploadedAt: string
}

export interface MediaListResponse {
  media: MediaItem[]
  cursor?: string
  hasMore: boolean
}

export interface PresignRequest {
  filename: string
  contentType: string
  size: number
}

export interface PresignResponse {
  uploadUrl: string
  publicUrl: string
  expiresAt: string
}

export interface MediaDeleteResponse {
  success: boolean
  key: string
}

export const ALLOWED_MEDIA_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'application/pdf',
] as const

export type AllowedMediaType = (typeof ALLOWED_MEDIA_TYPES)[number]

export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB
